import { request } from "./request.js";

async function get(key) {
    return await request("/administrator", { key: key }, "POST");
}

async function save(data) {
    return await request("/administrator/save", data, "POST");
}

export { get, save };
